import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import { AuthContext } from '../App';

export default function Register() {
  const [form, setForm] = useState({ username: '', password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.password !== form.confirm) return setError('הסיסמאות אינן תואמות');
    setLoading(true);
    try {
      await api.post('/auth/register', { username: form.username, password: form.password });
      const { data } = await api.post('/auth/login', { username: form.username, password: form.password });
      login(data);
      navigate('/dashboard');
    } catch (e) {
      setError(e.response?.data?.error || 'הרשמה נכשלה');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-title">📈 InvestTrack</div>
        <div className="auth-sub">צור חשבון חדש</div>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={submit}>
          <div className="form-group">
            <label className="form-label">שם משתמש</label>
            <input className="form-input" value={form.username} onChange={e => setForm({...form, username: e.target.value})} required autoFocus />
          </div>
          <div className="form-group">
            <label className="form-label">סיסמה</label>
            <input className="form-input" type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} required />
          </div>
          <div className="form-group">
            <label className="form-label">אימות סיסמה</label>
            <input className="form-input" type="password" value={form.confirm} onChange={e => setForm({...form, confirm: e.target.value})} required />
          </div>
          <button className="btn btn-primary" style={{width:'100%', justifyContent:'center'}} disabled={loading}>
            {loading ? 'יוצר חשבון...' : 'הרשמה'}
          </button>
        </form>
        <div className="auth-footer">
          כבר יש לך חשבון? <a onClick={() => navigate('/login')}>התחבר</a>
        </div>
      </div>
    </div>
  );
}
